var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F6F0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 13.4307C9.75 12.3346 10.06 11.6545 10.5051 11.2411C10.9586 10.8201 11.6514 10.5835 12.5972 10.5835H19.5417C20.4875 10.5835 21.1803 10.8201 21.6337 11.2411C22.0788 11.6545 22.3889 12.3346 22.3889 13.4307V18.2918C22.3889 19.388 22.0788 20.0681 21.6337 20.4814C21.1803 20.9025 20.4875 21.1391 19.5417 21.1391H12.5972C11.6514 21.1391 10.9586 20.9025 10.5051 20.4814C10.06 20.0681 9.75 19.388 9.75 18.2918V13.4307ZM12.5972 9.3335C11.4597 9.3335 10.4164 9.61777 9.65458 10.3252C8.8844 11.0403 8.5 12.0963 8.5 13.4307V18.2918C8.5 19.6262 8.8844 20.6822 9.65458 21.3974C10.4164 22.1048 11.4597 22.3891 12.5972 22.3891H19.5417C20.6791 22.3891 21.7225 22.1048 22.4843 21.3974C23.2545 20.6822 23.6389 19.6262 23.6389 18.2918V13.4307C23.6389 12.0963 23.2545 11.0403 22.4843 10.3252C21.7225 9.61777 20.6791 9.3335 19.5417 9.3335H12.5972ZM19.9318 14.2663C20.2015 14.0508 20.2455 13.6576 20.0301 13.3879C19.8147 13.1182 19.4214 13.0742 19.1517 13.2896L16.9785 15.0253C16.4912 15.413 15.6413 15.413 15.1539 15.0256L15.1532 15.0251L12.9881 13.2902C12.7187 13.0743 12.3254 13.1177 12.1095 13.3871C11.8937 13.6565 11.9371 14.0498 12.2065 14.2657L14.3731 16.0018L14.3747 16.003C15.3178 16.7538 16.8143 16.7538 17.7574 16.003L19.9318 14.2663Z",
    fill: "#7956D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/iconEmail.b2c36b6332cab7e031e7e8a66e797e02.svg";
export { ForwardRef as ReactComponent };